import { useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
  TextField,
  InputAdornment,
  IconButton,
  FormHelperText
} from "@mui/material";
import {
  VisibilityOutlined,
  VisibilityOffOutlined
} from "@mui/icons-material";

import messages from "../../assets/locale/messages";
import "./Input.scss";

const Input = ({
  name,
  value,
  onChange,
  onKeyDown,
  id,
  label,
  type,
  placeholder,
  required,
  isInputHasErr,
  errMsg,
  disabled,
  multiline,
  rows,
  maxRows,
  minRows,
  startAdornment,
  endAdornment,
  fullWidth,
  helperText,
  inputClass,
  inputWrapperClass,
  labelClassName,
  helperTextClass,
  labelAdornment,
  inputEndAdorment,
  ...props
}) => {
  const lang = useSelector((state) => state.locale.lang);
  const { inputsValidations } = messages[lang];

  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className={`input-wrapper ${inputWrapperClass}`}>
      <>
        <TextField
          id={id || name}
          name={name}
          label={
            <span className={`${labelClassName} `}>
              {label}
              {labelAdornment && (
                <span className="ms-2">{labelAdornment}</span>
              )}
            </span>
          }
          type={showPassword ? "text" : type}
          value={value}
          onKeyDown={onKeyDown}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          required={required}
          InputLabelProps={{
            required: false,
            shrink: true,
            variant: "outlined"
          }}
          disabled={disabled}
          error={isInputHasErr}
          fullWidth={fullWidth}
          multiline={multiline}
          rows={rows}
          maxRows={maxRows}
          minRows={minRows}
          className={`${inputClass} ${type === "file" && "file-input"}`}
          disableunderline="true"
          autoComplete="off"
          InputProps={{
            startAdornment: startAdornment ? (
              <InputAdornment position="start">
                {startAdornment}
              </InputAdornment>
            ) : null,
            endAdornment:
              type === "password" ? (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end">
                    {showPassword ? (
                      <VisibilityOutlined fontSize="small" />
                    ) : (
                      <VisibilityOffOutlined fontSize="small" />
                    )}
                  </IconButton>
                </InputAdornment>
              ) : (
                endAdornment
              ),
            // autoComplete: "new-password",
            form: {
              autoComplete: "off"
            }
          }}
          {...props}
        />
        {inputEndAdorment}
      </>

      <FormHelperText
        error={true}
        className={`${helperTextClass || "fsize-12"} ${
          lang === "en" ? "" : "text-end"
        } `}>
        {isInputHasErr ? inputsValidations[errMsg] : helperText}
      </FormHelperText>
    </div>
  );
};

export default Input;

Input.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired
  ]),
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
  id: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  type: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  isInputHasErr: PropTypes.bool,
  errMsg: PropTypes.string,
  disabled: PropTypes.bool,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  maxRows: PropTypes.number,
  minRows: PropTypes.number,
  inputEndAdorment: PropTypes.element,
  startAdornment: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  endAdornment: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  fullWidth: PropTypes.bool,
  helperText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  inputClass: PropTypes.string,
  inputWrapperClass: PropTypes.string,
  labelClassName: PropTypes.string,
  helperTextClass: PropTypes.string,
  labelAdornment: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ])
};

Input.defaultProps = {
  type: "text",
  fullWidth: true,
  value: ""
};
